import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as policy from '../policy'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: policy.RESOURCE.payload.dimension.partialId,
      partialId: policy.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'The date the current version of the policy was approved or took effect.',
    isOptional: true,
    name: 'Effective Date',
    partialId: PartialId.Standard.create('effective_date'),
    type: core.common.value.types.Intrinsic.Date,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
